import { render, staticRenderFns } from "./MDT.vue?vue&type=template&id=5c593cfe&"
import script from "./MDT.vue?vue&type=script&lang=ts&"
export * from "./MDT.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c593cfe')) {
      api.createRecord('5c593cfe', component.options)
    } else {
      api.reload('5c593cfe', component.options)
    }
    module.hot.accept("./MDT.vue?vue&type=template&id=5c593cfe&", function () {
      api.rerender('5c593cfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/text/sections/MDT.vue"
export default component.exports